/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import { Navbar } from 'react-bootstrap';
import Fade from "react-reveal/Fade";
import PropTypes from 'prop-types';

import BaseComponent from '../../../../panther/components/base/BaseComponent';
import Button from '../../../../panther/components/atoms/Button/Button';

import ActionCreator from '../../../../action/ActionCreator';
import style from './MicrositeHeader.css';

class MicrositeHeader extends BaseComponent {
    constructor(props) {
        super(props);
    }

    changeView() {
        ActionCreator.viewChange("intro");
    }

    render() {
        return (
            <Navbar.Header className="microsite-header">
                <Fade left distance="30px">
                <Navbar.Brand>
                        <div onClick={this.changeView.bind(this)} className="microsite-brand">
                            <h2 className="microsite-title">{this.props.intro.shortTitle}</h2>
                        </div>
                </Navbar.Brand>
                <Button
                    alignCenter
                    icon='fa-bars'
                    iconFa
                    className='menu-button w9'
                    primary
                    onClick={this.props.menuButtonOnClick}
                >
                    Menu
                </Button>
                </Fade>
            </Navbar.Header>
        );
    }
}

MicrositeHeader.propTypes = {
    intro: PropTypes.object,
    menuButtonOnClick: PropTypes.func
};

export default MicrositeHeader;